import { render, staticRenderFns } from "./dataprocess-form5.vue?vue&type=template&id=7f21a5fb&scoped=true&"
import script from "./dataprocess-form5.vue?vue&type=script&lang=ts&"
export * from "./dataprocess-form5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21a5fb",
  null
  
)

export default component.exports